export default {
  install: (app, options) => {
    const externalResourceHost = process.env.CDN_HOSTNAME || process.env.S3_HOSTNAME;
    app.config.globalProperties.$externalResourceHost = externalResourceHost;
    app.provide('$externalResourceHost', externalResourceHost);
  },
};
